import React, { useEffect, useState } from "react";

import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import {
  setPerPageSize,
  details,
  setDetails,
  deleteRecord,
  fetchList,
  changeOrder,
} from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import ViewDrawer from "./components/ViewDrawer";
import AddComponent from "./components/Form/AddComponent";
import EditComponent from "./components/Form/EditComponent";
import { SkillPoratraitBreadcrumb } from "../../../config/BreadcrumbConfig";
import { CONSTANT } from "../../../config/Constant";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { Button, Form } from "antd";
import { checkPrivileges } from "../../../config/Global";
import CommonModal from "../../../components/Modals/CommonModal";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FormBox, InputBox } from "../../../components/AntdAddons";
import  SortIcon from "../../../assets/images/sort.svg?react";
import ImportComponent from "./components/Form/ImportComponent";

import { setViewLoading } from "../../../store/CommonSlice";
import { setEditLoading } from "../../../store/CommonSlice";

const moduleInfo = {
  title: "Skill Portrait",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Skill Portrait"),
};

/**
 * Renders the Skill Portrait Management component.
 *
 * @return {ReactElement} The rendered Skill Portrait Management component.
 */
const SkillAssessment: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage, rowData } = useAppSelector((state) => state.skillPortrait);
  const userDetail = useAppSelector((state) => state.auth.userDetail);
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [isBookingVisible, setIsBookingVisible] = useState(false);
  const [viewDrawer, setViewDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();
  const [form] = Form.useForm();
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [changeOrderModal, setChangeOrderModal] = useState(false);
  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);


  // Function to fetch the record details and opens drawer of Edit or View 
  const getDetails = (data: any, type: string) => {
    if (type === CONSTANT.DRAWER_TYPE.VIEW) {
      dispatch(setViewLoading([true, data.id]));
    } else {
      dispatch(setEditLoading([true, data.id]));
    }
    dispatch(details(data.id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewDrawer(true);
          dispatch(setViewLoading([false, data.id]));
        }
        if (type === CONSTANT.DRAWER_TYPE.EDIT) {
          setEditDrawer(true);
          dispatch(setEditLoading([false, data.id]));
        }
      })
      .catch((error: any) => error);
  };

  // For change the sequence in the listing of skill portrait: start
  useEffect(() => {
    !rowData && dispatch(fetchList()).catch((error: any) => error);
    if (rowData) {
      const rowDataCopy = rowData.slice();
      setCategoryList(
        rowDataCopy?.sort((a: any, b: any) => {
          return a.order - b.order;
        })
      );
    }
  }, [rowData]);

  useEffect(() => {
    form.setFieldsValue({ orders: categoryList });
  }, [categoryList]);

  const handleSequenceChange = (result: any) => {
    if (result.source?.index >= 0 && result.destination?.index >= 0) {
      setCategoryList((prevCategoryList: any[]) => {
        const prevCategoryListCopy = prevCategoryList.slice();
        const dragged = prevCategoryListCopy.splice(result.source.index, 1)[0];
        prevCategoryListCopy.splice(result.destination.index, 0, dragged);

        const orderedData = prevCategoryListCopy.map(
          (category: any, index: any) => {
            return {
              ...category,
              order: index + 1,
            };
          }
        );
        form.setFieldsValue({ orders: orderedData });

        return orderedData;
      });
    }
  };
  
  // For change the sequence in the listing of skill portrait: End
  return (
    <>
      <ToolBar breadcrumbs={SkillPoratraitBreadcrumb}>
        <CreateButton
          name="Import"
          action={() => setIsBookingVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        <CreateButton
          action={() => setIsCreateVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        {checkPrivileges(
          userDetail,
          `${moduleInfo.permissionKeyPrefix}_CHANGE_ORDER`
        ) && (
          <Button
            className="primaryBtn"
            onClick={() => {
              setChangeOrderModal(true);
            }}
          >
            Change Order
          </Button>
        )}
        <RecordPerPage
          perPage={perPage}
          onChange={(perPageSize: number) => {
            dispatch(setPerPageSize(perPageSize));
          }}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}
          handleViewClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
          handleEditClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.EDIT);
          }}
          handleDeleteClick={setDeleteValue}
        />
        <ImportComponent
          titleName={moduleInfo.title}
          open={isBookingVisible}
          close={() => setIsBookingVisible(false)}
        />
        <AddComponent
          titleName={moduleInfo.title}
          open={isCreateVisible}
          close={() => setIsCreateVisible(false)}
        />
        <ViewDrawer
          titleName={moduleInfo.title}
          open={viewDrawer}
          close={() => dispatch(setDetails(null)) && setViewDrawer(false)}
        />
        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />

        <CommonModal
          title={`Change Order`}
          open={changeOrderModal}
          onCancel={() => setChangeOrderModal(false)}
          footer={[
            <Button
              key="change-order-2"
              htmlType="button"
              className="cancelBtn"
              onClick={() => setChangeOrderModal(false)}
            >
              Cancel
            </Button>,
            <Button
              key="change-order-1"
              htmlType="submit"
              type="primary"
              form="change-order-form"
            >
              Change Order
            </Button>,
          ]}
        >
          <>
            <FormBox
              id="change-order-form"
              form={form}
              onFinish={(formData: any) => {
                dispatch(changeOrder(formData))
                  .then(() => {
                    setChangeOrderModal(false);
                  })
                  .catch((error: any) => error);
              }}
            >
              <DragDropContext onDragEnd={handleSequenceChange}>
                <Droppable droppableId="sequence">
                  {(provided) => (
                    <Form.List {...provided.droppableProps} name="orders">
                      {(fields) => (
                        <div ref={provided.innerRef}>
                          {fields.map((field, index) => (
                            <Draggable
                              key={index}
                              draggableId={index.toString()}
                              index={index}
                            >
                              {(innerProvided) => (
                                <div
                                  ref={innerProvided.innerRef}
                                  {...innerProvided.draggableProps}
                                  {...innerProvided.dragHandleProps}
                                  key={`sequence-${index}`}
                                >
                                  <InputBox.Text
                                    required
                                    hidden={form.getFieldValue([
                                      "data",
                                      index,
                                      "is_deleted",
                                    ])}
                                    name={[index, "question"]}
                                    disabled
                                    addonBefore={<SortIcon />}
                                    className="change-sequence"
                                  />
                                </div>
                              )}
                            </Draggable>
                          ))}
                        </div>
                      )}
                    </Form.List>
                  )}
                </Droppable>
              </DragDropContext>

              <Button htmlType="submit" className="btn-primary" hidden>
                Save
              </Button>
            </FormBox>
          </>
        </CommonModal>
      </ContentBox>
    </>
  );
};

export default SkillAssessment;
